module.exports = __webpack_public_path__ + "img/bg.f393647e.png";